module.exports = __webpack_public_path__ + "img/a.be6cda2c.jpg";